import {
  getSubscription
} from '@/api/subscription.api'

const state = {
  subscription: {}
}

const mutations = {
  setSubscription (state, subscription) {
    state.subscription = subscription
  }
}

const getters = {
  subscription ({ subscription }) {
    return subscription
  }
}

const actions = {
  async fetchSubscription ({ commit }) {
    commit('setSubscription', await getSubscription())
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
